import React from "react";
import Overview from "../../Components/DashBoard/Overview";
import Mainpages from "../../Components/DashBoard/mainpage";

export default function MainPage() {
  return (
    <>
      <Overview />

      {/* The events and team management screens live below the summary so the
          existing CRUD stays exactly where administrators already expect it. */}
      <div style={{ marginTop: "2.5rem" }}>
        <Mainpages />
      </div>
    </>
  );
}
